<template>
	<div class="container" v-loading.fullscreen.lock="fullscreenLoading">
		<cnHeader ref="headerRef" @custom-event="getToken"></cnHeader>
		<div class="page_content">
			
			<!--添加客人-开始-->
			<el-dialog
			  title="添加客人"
			  :visible.sync="guestDialog"
			  :destroy-on-close="true"
			  width="500px">
			  <div class="add_guest_box">
			  	<div class="item">
					<span>姓名：</span>
					<input type="text" ref="guest_name" v-model="guest_name" class="inpt" maxlength="50" style="width: 300px;" placeholder="请输入客人姓名" />
				</div>
				<div class="item">
					<span>年龄：</span>
					<el-input-number v-model="guest_age" :min="minAge" :max="maxAge"></el-input-number>
				</div>
				<div class="btns">
					<el-button @click="guestDialog = false" style="width: 30%;">取 消</el-button>
					<el-button type="primary" @click="pushGuest()" style="width: 30%;">确 定</el-button>
				</div>
			  </div>
			</el-dialog>
			<!--添加客人-结束-->
			
			<!--房价列表-开始-->
			<el-dialog
			  :title="'近'+afterDays+'天房价'"
			  :visible.sync="roomPriceDialog"
			  :destroy-on-close="true"
			  width="700px">
			  <div class="roomprice_box">
			  	<el-table
			  	    :data="roomPriceData"
			  	    style="width: 100%"
					size="medium"
					height="400"
					>
					<el-table-column
					prop="ValidDate"
					label="日期"
					width="auto">
					</el-table-column>
					<el-table-column
					align="right"
					prop="RoomPrice"
					label="房间费"
					width="100">
					</el-table-column>
					<el-table-column
					align="right"
					prop="ExtraPrice"
					label="占床费"
					width="100">
					</el-table-column>
					</el-table>
			  </div>
			</el-dialog>
			<!--房价列表-结束-->
			
			<!--面包屑与公共提醒-开始-->
			<div class="ext_head">
				<div class="bread_crumb">
					<a href="/cn">首页</a><span class="space">/</span><a href="/cn/hotel">酒店</a><span class="space">/</span>自助下单
				</div>
			</div>
			<!--面包屑与公共提醒-结束-->
			
			<!--页面内容-开始-->
			<div class="booking_box">
				
				<!--左侧-开始-->
				<div class="bbox_left">
					<h1>自助下单</h1>
					<!--景点-开始-->
					<div class="bk_item">
						<div class="project_title">酒店名称</div>
						<div class="project_right_box">
							<div class="hotel_plan_box">
								<h3>{{hotelDetail.Title}}</h3>
								<h5>{{roomTypeTitle}}</h5>
							</div>
						</div>
					</div>
					<!--景点-结束-->
					<!--日期-开始-->
					<div class="bk_item">
						<div class="project_title">预订日期</div>
						<div class="project_right_box">
							<div class="arrival_date_box">
								<el-date-picker
								v-model="bookingDay" 
								type="daterange"
								:clearable=false
								:editable=false
								prefix-icon="none" 
								range-separator="至"
								start-placeholder="入住时间"
								end-placeholder="退房时间"
								:picker-options="pickerOptions"
								@change="changeDate"
								>
								</el-date-picker>
								<span class="nights" v-if="nights>0">共 <b>{{nights}}</b> 晚</span>
								<span class="room_price_box"><a href="javascript:void(0)" @click="roomPriceDialogHandle()">查看近{{afterDays}}天房价</a></span>
							</div>
						</div>
					</div>
					<!--日期-结束-->
					
					<!--房间数量与客人-开始-->
					<div class="bk_item">
						<div class="project_title">房间数量</div>
						<div class="project_right_box">
							
							<div class="room_nums">
								<div class="ctrl_box" @click="roomAmountHandle(-1)">-</div>
								<div class="num">{{roomAmount}}</div>
								<div class="ctrl_box" @click="roomAmountHandle(1)">+</div>
							</div>
							
							<div class="room_items">
								<div class="item" v-for="(item, index) in roomGuestList" :key="index">
									<h3>房间 {{item.room}}<span @click="guestDialogHandle(index)" v-if="item.guest.length<4">添加客人</span></h3>
									<ul v-if="item.guest.length>0">
										<li v-for="(x, y) in item.guest" :key="y">
											<div class="guest">{{x.realName}}，{{x.age}}岁</div>
											<div class="remove" @click="removeGuest(index,y)"></div>
										</li>
									</ul>
									<div v-else class="nothing">
										<p>未添加任何客人</p>
										<p style="color: #666;">{{childMinAge}}岁(含)以下儿童免收占床费</p>
									</div>
								</div>
							</div>
							
						</div>
					</div>
					<!--房间数量与客人-结束-->
					<!--备注-开始-->
					<div class="bk_item">
						<div class="project_title">备注信息</div>
						<div class="project_right_box">
							<div class="remark_box">
								<div class="remark_input">
									<el-input type="textarea" 
									:rows="5" 
									placeholder="如需帮助请在此输入您的需求!" 
									maxlength="200" 
									show-word-limit
									v-model="remark">
									</el-input>
								</div>
								<!-- <div class="friendly_tips">如因您提供的航班讯息出错，本公司不承担因此引起的责任。</div> -->
							</div>
						</div>
					</div>
					<!--备注-结束-->
					<!--联系人信息-开始-->
					<div class="bk_item">
						<div class="project_title">联系人信息</div>
						<div class="project_right_box">
							<div class="contact_box">
								<div class="item_box">
									<div class="l_title">姓名</div>
									<input type="text" ref="linkman" v-model="linkman" maxlength="50" class="r_input" placeholder="请输入姓名（必填）" />
								</div>
								<div class="item_box">
									<div class="l_title">手机</div>
									<input type="text" ref="mobile" v-model="mobile" maxlength="20" class="r_input" placeholder="请输入手机号码（必填）" />
								</div>
								<div class="item_box">
									<div class="l_title">邮箱</div>
									<input type="text" ref="email" v-model="email" maxlength="50" class="r_input" placeholder="请输入您的邮箱（必填）" />
								</div>
							</div>
						</div>
					</div>
					<!--联系人信息-结束-->
				</div>
				<!--左侧-结束-->

				<!--右侧-开始-->
				<div class="bbox_right">
					<div class="price_box">
						<div class="price">${{payablePrice}}</div>
						<div class="ext_price">含州税 ${{taxRatePrice}}</div>
						<div class="detail_price" v-if="payablePrice>0">
							<h5>费用明细</h5>
							<div class="item" v-if="roomPrice>0">房间费 ${{roomPrice}}</div>
							<div class="item" v-if="zhanchuangPrice>0">占床费 ${{zhanchuangPrice}}</div>
							<div class="item" v-if="xingliPrice>0">行李费 ${{xingliPrice}}</div>
						</div>
					</div>
					<div class="submit_btn">
						<el-button type="primary" round :loading="btnLoading" @click="submitBooking()">{{btnTxt}}</el-button>
					</div>
				</div>
				<!--右侧-结束-->
			</div>
			<!--页面内容-结束-->
		</div>
		<cnFooter></cnFooter>
	</div>
</template>


<script>
	import {
		getHotelDetail,
		checkToken,
		getHotelPrice,
		submitHotelBooking,
	} from '@/api/index.js'
	import {
		mixin
	} from '@/utils/mixin.js'
	import moment from 'moment';
	import cnHeader from '@/components/cn_header.vue'
	import cnFooter from '@/components/cn_footer.vue'
import { ColorPicker } from 'element-ui'
	export default {
		name: 'CN_HotelBooking',
		mixins: [mixin],
		components: {
			cnHeader,
			cnFooter,
		},
		data() {
			return {
				pickerOptions: {
					disabledDate(time) {
						//限制选择范围
						return time.getTime() < Date.now()+(1 * 24 * 60 * 60 * 1000) || time.getTime() > Date.now()+(365 * 24 * 60 * 60 * 1000)
					},
				},
				bookingDay: {},		//订单日期区间
				beginDate: '',		//开始日期
				endDate: '',		//结束日期
				baggagePrice: 0,	//行李费
				childMinAge: 2,		//儿童年龄,小于等于此值免收占床费
				
				
				total: 0,			//金额（不含税）
				taxRatePrice: 0,	//州税
				taxRate: 0.047,		//税率
				roomPrice: 0,		//房费
				zhanchuangPrice: 0,	//占床费
				xingliPrice: 0,		//行李费				
				payablePrice: 0,	//应付金额
				
				Id: '', //酒店Id
				roomAmount: 1,		//房间数量
				roomIndex: 0,		//当前操作的房间索引
				roomType: '',		//房型
				roomTypeTitle: '',	//房型名称
				nights: 0,			//住几晚
				
				maxOfRoom: 4,		//每个房间最大人数
				roomGuestList: [
					{
						"room": 1,
						"guest": []
					},
				],	//房间与客人列表
				
				fullscreenLoading: true, //loading状态
				language: 'cn', //语言版本
				terminal: 'pc', //终端，pc
				loginStatus: false,	//登录态
				token: null, //token
				hotelDetail: [], //详情
				priceList: [],	//价格列表
				
				guestDialog: false,	//添加客人弹窗状态
				guest_name: '',
				guest_age: 18,
				minAge: 1,	//最小支持年龄
				maxAge: 120,	//最大支持年龄
				
				linkman: '',	//联系人姓名
				mobile: '',		//联系人手机
				email: '',		//联系人邮箱
				remark:'',		//备注
				
				roomPriceDialog: false,	//房价列表弹窗状态
				afterDays: 90,			//向后多少天
				roomPriceData: [],
				
				btnLoading: false,
				btnTxt: '提交订单',
			}
		},
		created() {
			// 模拟获取url参数
			if (this.$route.query.Id != undefined && this.$route.query.Id !='') {
				this.Id = this.$route.query.Id
			}
			else{
				this.$message.error('Id不能为空');
			}
			
			if (this.$route.query.RoomType != undefined && this.$route.query.RoomType !='') {
				this.roomType = this.$route.query.RoomType
			}
			else{
				this.$message.error('RoomType不能为空');
			}
		},
		
		methods: {
			//接收组件回传Token
			getToken(token)
			{
				this.token = token
				if(this.token !=null && this.token !='')
				{
					this.loginStatus = true
				}
				// 获取详情
				this.getData()
				
				// this.token = token
				// if(this.token !=null && this.token !='')
				// {
				// 	this.loginStatus = true
					
				// 	this.getData()
				// }
				// else {
				// 	//跳转至登录页
				// 	this.$router.push({
				// 		path: '/cn/user/login?ReturnUrl=' + encodeURIComponent(window.location.href)
				// 	})
				// }
			},
			//获取数据
			async getData() {
				const { data: res } = await getHotelDetail(this.language, this.terminal, this.Id, this.token)
				if (res.errcode === 0)
				{
					this.fullscreenLoading = false
					this.hotelDetail = res.data
					this.childMinAge = parseInt(res.data.ChildMinAge)
					this.baggagePrice = parseFloat(res.data.BaggagePrice)
					
					//锁定房型
					if(this.hotelDetail.RoomTypes.length>0)
					{
						this.hotelDetail.RoomTypes.forEach((item, index) => {
							if(item.RoomType == this.roomType)
							{
								this.roomTypeTitle = item.Title
							}
						})
					}					
				}
				else {
					this.$message.error(res.errmsg);
				}
			},
			//选定日期
			async changeDate(val)
			{
				if(this.beginDate == this.formattedDate(this.bookingDay[0]) && this.endDate == this.formattedDate(this.bookingDay[1]))
				{
					return
				}
				else 
				{
					this.beginDate = this.formattedDate(this.bookingDay[0])
					this.endDate = this.formattedDate(this.bookingDay[1])
					
					//获取最新价格数据
					this.getPriceList()
				}
			},
			//房间数量操作
			roomAmountHandle(i)
			{
				if(i==-1)
				{
					//减
					if(this.roomAmount == 1) 
					{
						return
					}
					else
					{
						this.roomAmount--
						this.roomGuestList.splice(this.roomAmount, 1)
					}
				}
				else if(i==1)
				{
					//加
					if(this.roomAmount < 10)
					{
						this.roomAmount++
						let param = {
							room: this.roomAmount,
							guest: [],
						}
						this.roomGuestList.push(param)
					}
					else
					{
						return
					}
				}
				
				//计算金额
				this.calculatePrice()
			},
			// 获取价格表
			async getPriceList()
			{
				this.fullscreenLoading = true
				const { data: res } = await getHotelPrice(this.language, this.Id, this.roomType, this.beginDate, this.endDate)
				this.fullscreenLoading = false
				if (res.errcode === 0) 
				{
					this.priceList = res.data
					
					//计算金额
					this.calculatePrice()
				} 
				else {
					this.$message.error(res.errmsg);
				}
			},
			//计算金额
			calculatePrice()
			{
				if(this.beginDate =='' && this.endDate =='')
				return
				
				let fjfTotal = 0	//房间费（含度假村费）合计
				let zcfTotal =0 	//占床费合计
				let xlfTotal =0		//行李费，按房间一次性收取（只要有成人就算）
				let days = 0	//天数
								
				//日期遍历
				this.priceList.forEach((a, b) => {
					days++
					fjfTotal = days * parseFloat(a.RoomPrice) * this.roomGuestList.length	//房间费				
					
					this.roomGuestList.forEach((x, y) => {
						let adult = 0
						x.guest.forEach((q, t) => {								
							if(q.age > this.childMinAge)
							{
								adult++
							}
						})
						if(adult>2)
						{
							console.log('成人：',adult)
							zcfTotal += parseFloat(a.ExtraPrice)	//占床费
						}
					})					
				})
				
				//计算行李费
				if(this.baggagePrice > 0)					
				{					
					//房间遍历
					this.roomGuestList.forEach((x, y) => {
						let adult = 0
						x.guest.forEach((q, t) => {								
							if(q.age > this.childMinAge)
							{
								adult++
							}
						})					
						if(adult>0)
						{
							xlfTotal += this.baggagePrice
						}
					})
				}
				
				
				this.nights = days
				this.roomPrice = fjfTotal	//房间费
				this.zhanchuangPrice = zcfTotal	//占床费
				this.xingliPrice = xlfTotal	//行李费
				this.total = fjfTotal + zcfTotal + xlfTotal		//商品合计
				this.taxRatePrice = (this.total * this.taxRate).toFixed(2) 		//税费
				this.payablePrice = parseFloat(this.total) + parseFloat(this.taxRatePrice)	//应付金额
			},
			// 添加客人
			guestDialogHandle(roomIndex)
			{
				this.guest_name = ''
				this.guest_age = 18
				this.guestDialog = true
				this.roomIndex = roomIndex
			},
			// 保存客人
			pushGuest()
			{
				if(this.guest_name == '')
				{
					this.$message.error('请输入客人姓名')
					this.$refs.guest_name.focus()
					return
				}				
				this.guestDialog = false
				
				let guestParams = {
					realName: this.guest_name,
					age: this.guest_age,
				}
				this.roomGuestList[this.roomIndex].guest.push(guestParams)
				
				//计算金额
				this.calculatePrice()
			},
			// 移除客人
			removeGuest(a,b)
			{
				this.roomGuestList[a].guest.splice(b, 1)
				
				//计算金额
				this.calculatePrice()
			},
			//判断是否有房间中没有客人
			checkGuestCount()
			{
				let res = true
				for (let item of this.roomGuestList) {
					if(item.guest.length ==0 )
					{
						res = false
						break;
					}
				}
				return res
			},
			// 提交表单
			async submitBooking()
			{
				if(!this.loginStatus)
				{
					//调用头部组件中的登录方法
					this.$refs.headerRef.showHandleBox('login')
				}
				else
				{
					if(this.btnLoading)
					{
						return
					}
					
					if(this.beginDate =='' && this.endDate == '')
					{
						this.$message.error('请选择入住和退房时间。')
						return
					}
					
					if(!this.checkGuestCount())					
					{
						this.$message.error('对不起，房间内未添加任何客人。')
						return
					}				
					
					if(this.payablePrice == 0)
					{
						this.$message.error('订单金额错误。')
						return
					}
					
					if(this.linkman == '')
					{
						this.$message.error('请输入联系人姓名。')
						this.$refs.linkman.focus()
						return
					}
					if(this.mobile == '')
					{
						this.$message.error('请输入联系人手机号码。')
						this.$refs.mobile.focus()
						return
					}
					if(this.email == '')
					{
						this.$message.error('请输入联系人邮箱。')
						this.$refs.email.focus()
						return
					}
					const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
					if (!emailPattern.test(this.email)) {
						this.$message.error('联系人邮箱格式错误。')
						this.$refs.email.focus()
						return
					}
					
					this.btnLoading = true
					this.btnTxt = "提交中，请稍侯..."
					this.fullscreenLoading = true
					
					//组装请求数据
					let params={
						HotelId: this.Id,
						RoomType: this.roomType,
						Token: this.token,
						Terminal: this.terminal,
						Language: this.language,
						BeginDate: this.beginDate,
						EndDate: this.endDate,
						Nights: this.nights,
						LinkMan: this.linkman,
						Mobile: this.mobile,
						Email: this.email,
						Remark: this.remark,
						TotalPrice: this.total,
						TaxRatePrice: this.taxRatePrice,
						PayablePrice: this.payablePrice,
						Rooms: this.roomGuestList,
					}
					
					const { data: res } = await submitHotelBooking(params)
					this.fullscreenLoading = false
					if (res.errcode === 0) {
						this.$router.push({
							path: '/cn/user/booking_success?OrderNo='+res.data.OrderNo
						})
					} else {
						this.btnLoading = false
						this.btnTxt = "提交订单"
						this.fullscreenLoading = false
						this.$message.error(res.errmsg);
					}
				}
			},
			// 展开价格表
			roomPriceDialogHandle()
			{
				this.getRoomPriceData()
			},			
			// 获取价格表
			async getRoomPriceData()
			{
				this.fullscreenLoading = true
				let tmpBeginDay = moment().add(2, 'days').format('YYYY-MM-DD');
				let tmpEndDay = moment().add(this.afterDays+2, 'days').format('YYYY-MM-DD');
				const { data: res } = await getHotelPrice(this.language, this.Id, this.roomType, tmpBeginDay, tmpEndDay)
				this.fullscreenLoading = false
				if (res.errcode === 0) 
				{
					this.roomPriceData = res.data					
					this.roomPriceDialog = true
				} 
				else {
					this.$message.error(res.errmsg);
				}
			},
		}
	}
</script>

<style lang="less" scoped>
	.container {
		width: 100%;
		box-sizing: border-box;
		
		/*日期*/
		.arrival_date_box {
		
			.el-input__inner {
				width: 40%;
				border: #c4c4c4 solid 1px;
				background-color: #fff;
				padding: 0 15px;
				font-size: 15px;
				font-weight: 500;
				color: #000;
				background-position: right 10px center;
				background-repeat: no-repeat;
				background-size: 20px 20px;
				background-image: none;
				cursor: pointer;
			}
		
			::placeholder {
				font-weight: 400;
				color: #999;
			}
			
			.nights {
				display: inline-block;
				font-size: 12px;
				margin-left: 20px;
				color: #fff;
				background: #3D7856;
				padding: 0 10px;
				height: 24px;
				box-sizing: border-box;
				line-height: 24px;
				border-radius: 5px;
			}
			
			.room_price_box {
				display: inline-block;
				font-size: 13px;
				font-weight: 500;
				margin-left: 40px;
				
				a {
					color: #008768;
					text-decoration: underline;
				}
				a:hover {
					color: #000;
				}
			}
		}
		
		/*添加客人*/
		.add_guest_box {
			
			.item {
				margin: 20px 0;
				
				span {
					color: #111;
					display: inline-block;
					margin-right: 6px;
				}
				
				.inpt {
					height: 42px;
					line-height: 42px;
					font-size: 15px;
					box-sizing: border-box;
					padding: 0 6px;
					border: #999 solid 1px;
					outline: 0;
				}
				::placeholder {
					color: #bbb;
				}
			}
			.btns {
				text-align: right;
			}
		}


		/*房价列表*/
		.roomprice_box {
			height: 400px;
			box-sizing: border-box;
			position: relative;
			overflow: hidden;
		}
	}
	
	/deep/ .el-table__cell .cell {
		color: #111!important;
	}
	
	
	.submit_btn {
		margin-top: 40px;
	}
	
	
	.el-select {
		width: 100%;
	}
	
	.el-button {
		width: 100%;
		font-family: "PingFang SC", sans-serif, Helvetica, Arial;
		font-size: 15px;
		font-weight: 400;
		height: 42px;
		border-radius: 21px;
		-webkit-transition: all .3s ease;
	}
	.el-button--default {
		border: #666 solid 1px;
		color: #666;
		margin-left: 20px;
	}
	.el-button--default:hover {
		border: #3D7856 solid 1px;
		color: #3D7856;
	}
	.el-button.is-plain:focus  {
		border: #3D7856 solid 1px;
		color: #3D7856;
	}
	
	.el-button--primary {
		border: 0;
	}		
	.el-button--primary:focus {
		background-color: #3D7856;
	}
	.el-button--primary:hover {
		background-color: #000;
	}
</style>